import { transformMenuDetailToTabsConfig } from './transformMenuDetail';

export const buildFormValues = (role, menuDetailsData) => {
  if (!role) return {};

  const values = {
    roleName: role.name,
    description: role.description,
    status: role.isActive ? 'active' : 'inactive',
    roleType: role.roleType,
  };

  const tabs = transformMenuDetailToTabsConfig(menuDetailsData || []);

  (menuDetailsData || []).forEach((menu) => {
    values[`menu_${menu.id}`] = menu.isSelected === true;
  });

  tabs.forEach((tab) => {
    tab.subMenus?.forEach((sub) => {
      const allSelected = sub.permissions?.length && sub.permissions.every((p) => p.isSelected);
      values[`menu_${tab.id}_${sub.id}_enable_all`] = allSelected;

      sub.permissions?.forEach((perm) => {
        values[`menu_${tab.id}_${sub.id}_${perm.id}`] = perm.isSelected;
      });
    });
  });

  return values;
};

export const buildRolePayload = (data) => {
  const menuIds = Object.entries(data)
    .filter(([key, value]) => value && key.startsWith('menu_') && key.split('_').length === 2)
    .map(([key]) => Number(key.replace('menu_', '')));

  return {
    roleName: data.roleName,
    description: data.description,
    isActive: data.status === 'active',
    roleType: data.roleType,
    menuIds,
  };
};

export const buildRoleClaimPayload = (roleId, formData, menuDetailsData = []) => {
  const permissionIds = new Set();
  const subMenuIds = new Set();

  Object.entries(formData).forEach(([key, value]) => {
    if (!value || !key.startsWith('menu_') || key.includes('enable_all')) return;

    const [, topMenuId, subMenuId, permissionId] = key.split('_').map(Number);

    if (permissionId) {
      permissionIds.add(permissionId);
    }

    if (subMenuId && subMenuId !== topMenuId) {
      subMenuIds.add(subMenuId);
    }
  });

  menuDetailsData.forEach((menu) => {
    if (!menu.hasNotSubMenu) return;

    if (formData[`menu_${menu.id}`]) {
      menu.children?.forEach((perm) => {
        if (perm.isSelected) {
          permissionIds.add(perm.id);
        }
      });
    }
  });

  return {
    roleId,
    subMenuIds: [...subMenuIds],
    permissionIds: [...permissionIds],
  };
};
